import React, { useState, useRef } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(ChartDataLabels);

// Registra los componentes necesarios de Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

const PiesChart = () => {
  // Estado para el título del gráfico
  const [title, setTitle] = useState('Gráfico Circular Editable');
  
  // Estado para los valores y etiquetas del gráfico
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: '# of Votes',
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      },
    ],
  });

  // Estado para los nuevos valores y etiquetas a añadir
  const [newLabel, setNewLabel] = useState('');
  const [newValue, setNewValue] = useState('');

  // Referencia para capturar el gráfico
  const chartRef = useRef(null);

  // Función para agregar un nuevo dato
  const addData = () => {
    if (newLabel && newValue && !isNaN(newValue)) {
      const randomColor = `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(
        Math.random() * 255
      )}, ${Math.floor(Math.random() * 255)}, 0.6)`;
      setChartData({
        labels: [...chartData.labels, newLabel],
        datasets: [
          {
            ...chartData.datasets[0],
            data: [...chartData.datasets[0].data, Number(newValue)],
            backgroundColor: [...chartData.datasets[0].backgroundColor, randomColor],
            borderColor: [...chartData.datasets[0].borderColor, randomColor.replace('0.6', '1')],
          },
        ],
      });
      setNewLabel('');
      setNewValue('');
    }
  };

  // Función para manejar cambios en el título
  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  // Función para descargar el gráfico como PDF
  const downloadPDF = () => {
    const input = chartRef.current;
    if (input) {
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgWidth = 120;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.text(title, 105, 15, { align: 'center' });
        pdf.addImage(imgData, 'PNG', 40, 20, imgWidth, imgHeight);
        pdf.save('grafico.pdf');
      });
    }
  };

  return (
    <div style={{ textAlign: 'center', position: 'relative' }}>
      {/* Botón para descargar PDF */}
      <button
        onClick={downloadPDF}
        style={{
          position: 'absolute',
          top: '10px',
          left: '10px',
          padding: '10px 20px',
          fontSize: '15px',
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          zIndex: 1,
        }}
      >
        Descargar PDF
      </button>

      {/* Input para editar el título */}
      <div style={{ marginBottom: '10px' }}>
        <input
          type="text"
          value={title}
          onChange={handleTitleChange}
          placeholder="Editar título"
          style={{ fontSize: '16px', textAlign: 'center', padding: '4px', marginBottom: '10px' }}
        />
      </div>

      {/* Inputs para agregar nuevos datos */}
      <div style={{ marginBottom: '10px' }}>
        <input
          type="text"
          value={newLabel}
          onChange={(e) => setNewLabel(e.target.value)}
          placeholder="Nombre"
          style={{ marginRight: '5px', padding: '5px' }}
        />
        <input
          type="number"
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          placeholder="Valor"
          style={{ marginRight: '5px', padding: '5px' }}
        />
        <button
          onClick={addData}
          style={{ padding: '5px 10px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '5px' }}
        >
          Agregar
        </button>
      </div>

      {/* Gráfico circular */}
      <div ref={chartRef} style={{ width: '320px', height: '320px', margin: '0 auto 30px' }}>
        <Pie
          data={chartData}
          options={{
            plugins: {
              datalabels: {
                display: true,
                color: '#000',
                font: {
                  weight: 'bold',
                  size: 14,
                },
                formatter: (value, context) => {
                  const data = context.chart.data.datasets[0].data;
                  const total = data.reduce((acc, val) => acc + val, 0);
                  const percentage = ((value / total) * 100).toFixed(0);
                  return `${percentage}%`;
                }
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default PiesChart;
